// 提现列表顶部筛选tab
export let withdrawTabLabels = [
  {
    label: '所在地',
    type: 'select',
    value: 'city',
    filterable: true,
    clearable: true,
    options: [
    ]
  },
  {
    label: '提现时间',
    type: 'time-slot',
    value: 'withdrawalsDate',
    startName: 'withdrawalsDateStart',
    endName: 'withdrawalsDateEnd',
    clearable: true
  },
  {
    label: '提现金额',
    type: 'price-slot',
    clearable: true,
    minName: 'moneyRangeStart',
    maxName: 'moneyRangeEnd',
    value: 'withdrawalsMoney'
  },
  {
    label: '提现方式',
    type: 'select',
    value: 'withdrawalsChannel',
    filterable: true,
    clearable: true,
    options: [
      {
        value: 'WXPAY',
        label: '微信零钱'
      },
      {
        value: 'BANK_CARD',
        label: '银行卡'
      }
      // 'BANK_CARD', 'WXPAY', 'ALIPAY'
    ]
  }
]
// 提现列表 大分类
export let typeTabs = [
  {
    label: '全部列表',
    value: 'ALL'
  },
  {
    label: '待审核列表',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '处理中列表',
    value: 'PROCESSING'
  },
  {
    label: '已完成列表',
    value: 'COMPLETED'
  },
  {
    label: '异常列表',
    value: 'FAILED'
  },
  {
    label: '已取消列表',
    value: 'CANCELLED'
  }
]

// 提现列表表头
export let tableLabels = [
  {
    label: '业务流水号',
    value: 'serialNumber'
  },
  {
    label: '生命银行用户',
    value: 'user.firstName'
  },
  {
    label: 'C端手机号',
    value: 'user.mobile'
  },
  {
    label: '所在地',
    value: 'user.city'
  },
  //   {
  //     label: '所属区域',
  //     value: ''
  //   },
  {
    label: '收款方账户名称',
    value: 'accountName'
  },
  {
    label: '提现方式',
    value: 'accountType'
  },
  // {
  //   label: '银行预留手机号',
  //   value: 'bankAccount.mobile'
  // },
  // {
  //   label: '收款账户',
  //   value: 'bankAccount.cardNumber'
  // },
  {
    label: '提现金额（元）',
    value: 'withdraw_amount'
  },
  {
    label: '实际金额（元）',
    value: 'withdraw_actualAmount'
  },
  {
    label: '提现时间',
    value: 'withdraw_date'
  },
  {
    label: '状态',
    value: 'withdraw_status'
  }
  // {
  //   label: '提现描述',
  //   value: 'statusDescription'
  // }
  // {
  //   label: '状态',
  //   value: 'createdDate'
  // },
]
// 审核radios
export let awardRadios = [
  {
    label: '审核通过',
    value: 'COMPLETED'
  },
  {
    label: '驳回申请',
    value: 'REJECTED'
  }
]
